import { useIntl } from 'react-intl';
import byteSize from 'byte-size';

export const getByteSize = (size: number) => {
  const intl = useIntl();
  const { value, unit } = byteSize(size);
  const formattedValue = intl.formatNumber(parseFloat(value));
  return `${formattedValue} ${unit}`;
};
